import { type CSSProperties } from 'react';

import { type AdTileDimensions } from '../types.ts';

// Creatives arrive at a fixed pixel size, and both the box the tile reserves and the scale
// factor are derived from it in CSS, so the size has to reach the stylesheet as variables.
export const getAdTileSizeVars = ({
    width,
    height,
    heightHold,
    widthHold,
}: AdTileDimensions): CSSProperties => {
    const vars = {
        '--ad-tile-width': widthHold || width,
        '--ad-tile-height': heightHold || height,
    };

    return vars as CSSProperties;
};
